export enum OrderTypeEnum {
  Delivery = "Delivery",
  Pickup = "Pickup",
}
